// https://github.com/developit/tags-input

import tagsInput from "tags-input";
import "tags-input/tags-input.css";

function initTagsInput() {
  [].forEach.call(document.querySelectorAll('input[type="tags"]'), tagsInput);
}

$(document).on("turbolinks:load", initTagsInput);



// WEBPACK FOOTER //
// ./app/javascript/support/tags-input.js